// Axios
import axios from 'axios';

// React
import React, { useEffect, useState, useRef } from 'react';
import 'react-tagsinput/react-tagsinput.css';

// Telegram UI
import { AppRoot, Avatar, Badge, Blockquote, Cell, IconButton, Navigation, Section, Spinner, Switch } from '@telegram-apps/telegram-ui';

// VK
import { Snackbar } from '@vkontakte/vkui';
import { Icon28CheckCircleFill } from '@vkontakte/icons';

// Icons
import { ReactComponent as ModeIcon } from "../assets/mode.svg";

const tg = window.Telegram.WebApp;

const SourcesLibPage = ({ activePanel, setActivePanel, avatarSrc, selectedGroup, themes, setGptLink, setGptMedia, setGptText, setSelectedGroup, premodePosts, setChannels, setGroups, setPremodePosts, selectedStreamIndex, setSelectedStreamIndex, stream, setStream }) => {
    const filteredPosts = premodePosts.filter(post => selectedGroup === null || post.id === selectedGroup.id);
    const streams = selectedGroup.streams;
    const [theme, setTheme] = useState(stream.theme);
    const [selectedTheme, setSelectedTheme] = useState(stream.theme);
    const [sources, setSources] = useState(stream.sources);
    const [snackbar, setSnackbar] = useState(null);

    useEffect(() => {
        const backButtonHandler = () => {
            tg.HapticFeedback.impactOccurred('heavy');
            tg.HapticFeedback.notificationOccurred("success");
            setActivePanel('sources');
        };

        if (activePanel === 'sourceslib') {
            tg.BackButton.show();
            console.log(streams)
            tg.BackButton.onClick(backButtonHandler);
        }

        return () => {
            tg.BackButton.offClick(backButtonHandler);
        };
    }, [activePanel]);

    useEffect(() => {
        const saveSources = async () => {
            const url = 'https://api.gmpapp.ru/save_sourceslib';

            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ group_id: selectedGroup.id, stream_id: stream.id, sources: stream.sources, theme: stream.theme }),
                });

                if (!response.ok) {
                    // Здесь можно обрабатывать неуспешные коды ответов
                    console.error('Error:', response.status, response.statusText);
                } else {
                    // Если ответ успешен, можно сделать что-то с данными
                    const data = await response.json();
                    console.log('Success:', data);
                }
            } catch (error) {
                console.error('Error streams sending', error);
            }
        };

        saveSources();
    }, [stream]);

    const openError = (text) => {
        setSnackbar(
            <Snackbar
                onClose={() => setSnackbar(null)}
                before={<Icon28CheckCircleFill fill="var(--vkui--color_icon_positive)" />}
            >
                {text}
            </Snackbar>,
        );
    };

    const handleChange = (theme_id) => {
        const themeIndex = parseInt(stream.theme, 10);
        const prev_sources = (themes[themeIndex] && themes[themeIndex].sources) ? themes[themeIndex].sources : [];
        const new_sources = themes[parseInt(theme_id, 10)].sources

        if (theme_id === parseInt(stream.theme, 10)) {
            setStream((prevStream) => ({
                ...prevStream,
                theme: String(null),
                sources: prevStream.sources.filter(source => !new_sources.includes(source)) // Убираем текущие
            }));
        } else {
            setStream((prevStream) => ({
                ...prevStream,
                sources: prevStream.sources.filter(source => !prev_sources.includes(source)) // Убираем текущие
            }));
            setStream((prevStream) => ({
                ...prevStream,
                theme: String(theme_id),
                sources: Array.from(new Set([...prevStream.sources, ...new_sources])) // Устанавливаем новые
            }));

            openError(`Установлена тема: ${themes[theme_id].emoji}${themes[theme_id].name}`);
        }
    };

    return (
        <div className="wrapperUI">
            <AppRoot platform='ios'>
                <Section className='sectionChannel sectionPrompts' header='Выберите подборку источников'>
                    {themes
                        .map((theme) => (
                            <Cell
                                key={theme.id}
                                onClick={() => { tg.HapticFeedback.impactOccurred('heavy'); tg.HapticFeedback.notificationOccurred("success"); handleChange(theme.id); }}
                                className='settingsItem'
                                before={
                                    <span
                                        style={{
                                            width: "28px",
                                            height: "28px",
                                            marginBottom: "1px",
                                            borderRadius: "6px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        }}
                                    >
                                        {theme.emoji}
                                    </span>
                                }
                                after={parseInt(stream.theme, 10) === theme.id ? <Navigation>Установлена</Navigation> : null}>{theme.name}
                            </Cell>
                        ))}
                </Section>
                {snackbar}
            </AppRoot >
        </div >
    );
};

export default SourcesLibPage;